import { Component, OnInit } from '@angular/core';
import { CommonFunctionService, UserMerchantData } from '../../../services/Common/common-function.service';
import { SettingsService } from '../../../services/settings/settings.service';
const swal = require('sweetalert');
import { Router, ActivatedRoute } from "@angular/router";
import { PayoutService } from 'src/app/services/payout.service';
@Component({
  selector: 'app-view-payoutcontactdetails',
  templateUrl: './view-payoutcontactdetails.component.html',
  styleUrls: ['./view-payoutcontactdetails.component.scss']
})
export class ViewPayoutcontactdetailsComponent implements OnInit {
  NewAccount:boolean=false
 noImageavalabel:boolean=false;
  Imageavalabel:boolean=false;
 pdffile:boolean=false;



  content:any;
  CrossAccNo:boolean=true;
  FullAccNo:boolean=false
  viewid:any;
  maxFileSize = 40000;
  maxWidth = 200;
  maxHeight = 200;
  Accountdetails;
  FullAccountNumber:any;
  constructor(private commonfunction: CommonFunctionService,private service: PayoutService,private router:Router,private route: ActivatedRoute) { 
    this.route.params.subscribe(params => {
      this.viewid = params['Id'];
    });
  }

  ngOnInit() {
    this.getUserPermissions();
    let merchantdata: UserMerchantData = this.commonfunction.getUserMerchantData();
    this.service.viewPayOutAccountdetails(merchantdata.MerchantKeyId,this.viewid).subscribe(result => {
     if(result !=null)
     {
       this.Accountdetails=result;

       if(this.Accountdetails.AccountNumber !=null)
       {
         this.FullAccountNumber=this.Accountdetails.AccountNumber
        var first6digits = this.Accountdetails.AccountNumber.slice(0, 6);
        var last4digits = this.Accountdetails.AccountNumber.slice(-4);
        this.Accountdetails.AccountNumber = first6digits+"-XXXXXXX-"+last4digits;
       }

       this.content=this.Accountdetails.Content
       if(result.Content !=null)
       {
        this.noImageavalabel=false;
        this.Imageavalabel=true;
        this.pdffile=false;

        if(result.ContentType=="application/pdf")
        {
          this.pdffile=true;
          this.noImageavalabel=false;
          this.Imageavalabel=false;

          
        }
       }
       else{
         this.Imageavalabel=false;
         this.noImageavalabel=true;
         this.pdffile=false;
       }

     }
      
  
   }) 
  }


  DeletePayoutSecurity()
  {
    let merchantdata: UserMerchantData = this.commonfunction.getUserMerchantData();
    this.service.DeletePayoutSecurity(merchantdata.MerchantKeyId,+this.viewid).subscribe(result => {
      if(result !=null)
      {
        swal("Added", "Delete Successfully", "success");
        this.router.navigate(["PayOut/managePayoutAccountdetails"]);
      }
  });
}


onSelect(x) {
  this.FullAccNo=true;
  this.CrossAccNo=false;
 }


 Viewpdf()
{
  var byteCharacters = atob(this.content);
  var byteNumbers = new Array(byteCharacters.length);
  for (var i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  var byteArray = new Uint8Array(byteNumbers);
  var file = new Blob([byteArray], { type: 'application/pdf;base64' });
  var fileURL = URL.createObjectURL(file);
  window.open(fileURL);

}


getUserPermissions() {
  const merchantdata: UserMerchantData = this.commonfunction.getUserMerchantData();
  this.service.GetuserRoleBasedPermissions(merchantdata.UserId, "Merchant").subscribe(result => {
    if (result != null) {
      for (var i in result) {
        if (result[i].UserPermission == 'PayOut') {
          var type = result[i].Type;
          if (type == 'R') 
          {
              
              this.NewAccount=false;
              
             
          }
         else if (type == 'RW') 
          {
            this.NewAccount=true;
           
          }
         else if (type == 'RWD') 
          {
            this.NewAccount=true;
          }
        }
      }

    }

  });
}
}
